import { ConditionsAddressedBlockNode as ConditionsAddressedBlockSchema } from '@seen/core/tiptap/schema'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { ConditionsAddressedBlockNodeView } from '#src/components/rich-text-editor/ConditionsAddressedBlockNode/ConditionsAddressedBlockNodeView.tsx'
import type { ConditionsAddressedBlockNodeOptions } from '#src/components/rich-text-editor/ConditionsAddressedBlockNode/types.ts'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    conditionsAddressedBlock: {
      insertConditionsAddressedBlock: () => ReturnType
    }
  }
}

export const ConditionsAddressedBlockNode =
  ConditionsAddressedBlockSchema.extend<ConditionsAddressedBlockNodeOptions>({
    addOptions() {
      return {}
    },

    addNodeView() {
      return ReactNodeViewRenderer(ConditionsAddressedBlockNodeView)
    },

    addCommands() {
      return {
        insertConditionsAddressedBlock:
          () =>
          ({ commands }) => {
            return commands.insertContent({
              type: this.name,
            })
          },
      }
    },
  })
